import {
  Box,
  Grid,
  IconButton,
  AppBar as MuiAppBar,
  Toolbar,
  styled,
  useTheme,
} from "@mui/material";

import ChangeThemeButton from "components/ChangeThemeButton";
import { LANDING_PAGE_URL } from "config/Configuration";
import LogoutModal from "components/SideMenuItems/Logout";
import Navbar from "components/layout/Desktop/Navbar";
import { SanaCashLogo } from "assets/Icon";
import UserOptions from "./Components/UserOptions";
import { useIsUserBlocked } from "hooks/useIsUserBlocked";
import { useState } from "react";

function TopAppBar({ open, handleDrawerOpen, drawerWidth }) {
  const theme = useTheme();
  const isUserBlocked = useIsUserBlocked();

  const [openLogout, setOpenLogout] = useState(false);

  return (
    <>
      <AppBar position="fixed" open={open} drawerWidth={drawerWidth}>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <Box display="flex" alignItems="center">
                {!isUserBlocked && (
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{ mr: 2, ...(open && { display: "none" }) }}
                  >
                    <ion-icon name="menu-outline"></ion-icon>
                  </IconButton>
                )}

                <BoxLogo>
                  <a href={LANDING_PAGE_URL}>
                    <SanaCashLogo fill={theme.palette.modules.logoColor} />
                  </a>
                </BoxLogo>
              </Box>
            </Grid>

            <Grid item xs={6} textAlign="center">
              {!isUserBlocked && <Navbar />}
            </Grid>

            <Grid item xs={3} textAlign="right">
              <UserOptions
                setOpenLogout={setOpenLogout}
              />

              <ChangeThemeButton />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {openLogout && (
        <LogoutModal open={openLogout} onClose={() => setOpenLogout(false)} />
      )}
    </>
  );
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, drawerWidth }) => ({
  background: theme.palette.modules.appBar,
  boxShadow: "none",
  filter: "drop-shadow(0 1px 10px rgba(32,108,193,.501961))",
  zIndex: "1100",

  transition: theme.transitions.create(["margin", "width", "zIndex"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    zIndex: "900",
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const BoxLogo = styled(Box)(({ theme }) => ({
  a: {
    maxWidth: "120px",
    display: "flex",
    margin: "auto",
  },
}));

export default TopAppBar;
